import { useState } from 'react';
import { Box, Button, Dialog, IconButton, LinearProgress, Typography } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import './Dashboard.css';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { StaticDatePicker } from '@mui/x-date-pickers';
import InfoComponent from '../customComponents/InfoComponent';

export const dayList = [
    { id: 0, title: "Sunday" },
    { id: 1, title: "Monday" },
    { id: 2, title: "Tuesday" },
    { id: 3, title: "Wednesday" },
    { id: 4, title: "Thursday" },
    { id: 5, title: "Friday" },
    { id: 6, title: "Saturday" }
];

export const getDayName = (dayOfWeek: number): string => {
    return dayList.find((day) => day.id === dayOfWeek)?.title || '';
};

const DateSelectable: React.FC<{
    selectedDate: Dayjs;
    setSelectedDate: (selectedDate: Dayjs) => void;
    loading: boolean;
    top: number;
}> = ({ selectedDate, setSelectedDate, loading, top }) => {

    const [openCalendar, setOpenCalendar] = useState(false);

    return (
        <>
            <Box sx={{
                position: 'fixed',
                zIndex: 11,
                top: { top },
                left: 0,
                right: 0,
                height: 45,
                backgroundColor: 'primary.main',
                color: 'text.primary',
                borderBottom: '1px solid #ddd',
                padding: '8px 16px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            >
                <InfoComponent infoContent={'Go yesterday'} >
                    <IconButton size='small' disabled={loading} onClick={() => setSelectedDate(selectedDate.subtract(1, 'day'))}>
                        <KeyboardArrowLeftIcon />
                    </IconButton>
                </InfoComponent>
                <Dialog open={openCalendar} onClose={() => setOpenCalendar(false)}>
                    <StaticDatePicker
                        value={selectedDate}
                        onChange={(newValue) => { setSelectedDate(newValue || dayjs()); setOpenCalendar(false); }}
                        disabled={loading}

                    />
                    {!(dayjs().format('MM/DD/YYYY') === selectedDate.format('MM/DD/YYYY')) &&
                        <Box display='flex' flexDirection='row' justifyContent='flex-end' sx={{ padding: '0 8px 8px 0 ' }} >
                            <Button
                                disabled={loading}
                                onClick={() => { setSelectedDate(dayjs()); setOpenCalendar(false); }}
                                variant="contained"  >
                                Go today {dayjs().format('MM/DD/YYYY')}
                            </Button>
                        </Box>}
                </Dialog>
                <InfoComponent infoContent={'Salect date by date picker'} >
                    <Box sx={{ margin: '0 5px' }}>
                        <Typography sx={{ cursor: 'pointer' }} onClick={() => setOpenCalendar(true)} variant="h6">{getDayName(selectedDate.day())}, {selectedDate.format('MM/DD/YYYY')} </Typography>
                    </Box>
                </InfoComponent>
                <InfoComponent infoContent={'Go tomorrow'}  >
                    <IconButton size='small' disabled={loading} onClick={() => setSelectedDate(selectedDate.add(1, 'day'))}>
                        <KeyboardArrowRightIcon />
                    </IconButton>
                </InfoComponent>
            </Box>
            {loading && <LinearProgress color="primary" sx={{
                position: 'fixed',
                zIndex: 12,
                left: 0,
                right: 0,
            }} />}
            <Box sx={{ paddingTop: `${top}px` }}></Box>
        </>
    );
};

export default DateSelectable;